var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Layer } from '@timeflies/tilemap-utils';
import React from 'react';
import { Container } from 'react-pixi-fiber';
import { TilemapLayer } from './tilemap-layer';
import { TilemapTilesStates } from './tilemap-tiles-states';
export var TilemapComponent = function (_a) {
    var mapSheet = _a.mapSheet, mapTexture = _a.mapTexture, onTileMouseHoverRaw = _a.onTileMouseHover, tilesRange = _a.tilesRange, tilesAction = _a.tilesAction, tilesCurrentAction = _a.tilesCurrentAction, children = _a.children;
    var onTileMouseHoverRef = React.useRef(onTileMouseHoverRaw);
    onTileMouseHoverRef.current = onTileMouseHoverRaw;
    var onTileMouseHover = React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        onTileMouseHoverRef.current.apply(onTileMouseHoverRef, args);
    }, [onTileMouseHoverRef]);
    var commonProps = {
        mapSheet: mapSheet, mapTexture: mapTexture, onTileMouseHover: onTileMouseHover
    };
    var backgroundLayer = Layer.getTilelayer('background', mapSheet);
    var backgroundExtraLayerList = Layer.getBackgroundExtraLayers(mapSheet);
    var obstaclesLayer = Layer.getTilelayer('obstacles', mapSheet);
    var foregroundLayerList = Layer.getForegroundLayers(mapSheet);
    var renderLayer = function (props) { return (React.createElement(TilemapLayer, __assign({ key: props.layer.name }, commonProps, props))); };
    var background = renderLayer({
        layer: backgroundLayer,
        interactive: true
    });
    var backgroundExtras = backgroundExtraLayerList.map(function (layer) { return renderLayer({ layer: layer }); });
    var obstaclesAndEntities = renderLayer({
        layer: obstaclesLayer,
        characters: children
    });
    var foreground = foregroundLayerList.map(function (layer) { return renderLayer({ layer: layer }); });
    return React.createElement(Container, { interactive: true, mouseout: function () { return onTileMouseHover(null); } },
        background,
        backgroundExtras,
        React.createElement(TilemapTilesStates, { backgroundLayer: backgroundLayer, mapSheet: mapSheet, tilesRange: tilesRange, tilesAction: tilesAction, tilesCurrentAction: tilesCurrentAction }),
        obstaclesAndEntities,
        foreground);
};
